module.exports = function (bootstrap) {
    bootstrap.directive('siteHeaderTemp', ["modal", "navigation", "brand", "services", "session", "$timeout", "$window", "$sce", function (modal, navigation, brand, services, session, $timeout, $window, $sce) {
        return {
            replace: true,
            transclude: true,
            scope: {
                showLanguages: "=",
                extraButton: "="
            },
            link: function (scope, element) {
                var nav = element.find('nav');

                var body = angular.element('body');
                body.on('click', function (evt) {
                    var target = body.find('.headerNeedHelpParent');
                    if (target) {
                        if (!(target.find(evt.target).length > 0)) {
                            scope.showNeedHelp = false;
                            scope.$apply();
                        }
                    }

                    target = body.find('.headerFontSizerParent');
                    if (target) {
                        if (!(target.find(evt.target).length > 0)) {
                            scope.showFontSizer = false;
                            scope.$apply();
                        }
                    }

                    target = body.find('.headerLanguageMenuParent');
                    if (target) {
                        if (!(target.find(evt.target).length > 0)) {
                            scope.showLangMenu = false;
                            scope.$apply();
                        }
                    }

                    target = body.find('.loginBox');
                    if (target) {
                        if (!(target.find(evt.target).length > 0)) {
                            scope.showLoginBox = false;
                            scope.$apply();
                        }
                    }

                    target = body.find('.yourAccountMenu');
                    var buttonTarget = body.find('.yourAccountButton');

                    if (target && buttonTarget) {
                        if (!angular.element(evt.target).closest(target).length && !angular.element(evt.target).closest(buttonTarget).length) {
                            scope.extraOpen = false;
                            scope.$apply();
                        }
                    }
                });

                body.on('keydown', function (evt) {
                    if (evt.which === 9 || evt.keyCode === 9) {
                        $timeout(function () {
                            var target = body.find(':focus');

                            hideHeaderMenuItemIfTabbingOut(target, ['.headerNeedHelpParent'], 'showNeedHelp');
                            hideHeaderMenuItemIfTabbingOut(target, ['.headerFontSizerParent'], 'showFontSizer');
                            hideHeaderMenuItemIfTabbingOut(target, ['.headerLanguageMenuParent'], 'showLangMenu');
                            hideHeaderMenuItemIfTabbingOut(target, ['.loginBox'], 'showLoginBox');
                            hideHeaderMenuItemIfTabbingOut(target, ['.yourAccountMenu', '.yourAccountButton'], 'extraOpen');

                            scope.$apply();
                        });
                    }
                });

                function hideHeaderMenuItemIfTabbingOut(target, menuParentClasses, menuBoolean) {
                    var i = 0,
                        nonHighlightedElementCount = 0;

                    if (scope[menuBoolean]) { //if dropdown is open
                        for (i; i < menuParentClasses.length; i++) {
                            if (!target.closest(menuParentClasses[i]).length) {
                                nonHighlightedElementCount++;
                            }
                        }
                        if (nonHighlightedElementCount === menuParentClasses.length) { //if dropdown is open but no related elements are highlighted, close dropdown.
                            scope[menuBoolean] = false;
                        }
                    }
                }

                scope.openCloseTouch = function () {
                    if (!nav.hasClass('ng-animate')) {
                        scope.navopen = !scope.navopen;
                    }
                };
            },
            controller: 'headerController',
            templateUrl: "home.appTemplate.html/chmhom/directives/header"
        };
    }]);
    bootstrap.controller('headerController', [
        "$scope", "$q", "$window", "coremetrics", "aemContent", "$sce", "$document", "sessionData", "invisibleForm", "clickToChat", "modal", "navigation", "brand", "appConfig", "services", "session", "$timeout", "$state", "$cookies", "coremetricsConversionTracker", "taglines", "appId", "$location", "hook", "$anchorScroll", "smoothFocus",
        function ($scope, $q, $window, coremetrics, aemContent, $sce, $document, sessionData,  invisibleForm, clickToChat, modal, navigation, brand, appConfig, services, session, $timeout, $state, $cookies, coremetricsConversionTracker, taglines, appId, $location, hook, $anchorScroll, smoothFocus) {

            var REGIONAL_LANGUAGES_CONTENT_ID = 'REGIONAL_LANGUAGES',
                MBR_MEANINGFUL_ACCESS_LINK_ID = 'MBR_MEANINGFUL_ACCESS_LINK';

            var needHelpCoremtricsFlag = false;
            // Get Languages content for taglines.
            var allLanguages = {};
            taglines.getAllLanguages().then(
                function (response) {
                    allLanguages = response;
                }, function () {
                }
            );

            appConfig.getAll().then(function (appConfigResponse) {
                sessionData.appConfig = angular.extend({}, appConfigResponse);
                $scope.disableNavTabs = sessionData.appConfig.PROVIDER &&
                    sessionData.appConfig.PROVIDER.PVD_HIDE_NAV_TABS &&
                    sessionData.appConfig.PROVIDER.PVD_HIDE_NAV_TABS.booleanValue;
                $scope.isVitalsActive = sessionData.appConfig.FIND_A_DOCTOR &&
                    sessionData.appConfig.FIND_A_DOCTOR.VITALS_LIVE &&
                    sessionData.appConfig.FIND_A_DOCTOR.VITALS_LIVE.booleanValue;
                $scope.isVitalsActive = $scope.isVitalsActive && brand.current.isVitalsActive;
            });

            // $scope.disableNavTabs= sessionData && sessionData.appConfig && sessionData.appConfig.PROVIDER &&
            //     sessionData.appConfig.PROVIDER.PVD_HIDE_NAV_TABS &&
                // sessionData.appConfig.PROVIDER.PVD_HIDE_NAV_TABS.booleanValue;


            $scope.switchExtraOpen = function () {
                $scope.extraOpen = !$scope.extraOpen;
            };

            $scope.switchLoginBox = function () {
                $scope.showMobileLoginBox = !$scope.showMobileLoginBox;
                $timeout(function () {
                    document.activeElement.blur();
                    smoothFocus.clearTab();
                    smoothFocus.setTab(document.activeElement);
                }, 0);
            };

            var body = angular.element('body');
            body.on('click', function (evt) {

                var target = body.find('.headerLoginBox');
                var buttonTarget = body.find('.login-button');
                var buttonCheck = buttonTarget[0] && buttonTarget[0].className == evt.target.className ? [1] : [] || buttonTarget.find(evt.target);
                var targetCheck = target.find(evt.target);

                if (target && buttonTarget) {
                    if (!(targetCheck.length > 0 || buttonCheck.length > 0)) {
                        $scope.showMobileLoginBox = false;
                        $scope.$apply();
                    }
                }

                target = body.find('.yourAccountMenu');
                buttonTarget = body.find('.yourAccountButton');
                buttonCheck = (buttonTarget[0] == evt.target || buttonTarget == evt.target) ? [1] : buttonTarget.find(evt.target);
                targetCheck = target.find(evt.target);

                if (target && buttonTarget) {
                    if (!(targetCheck.length > 0 || buttonCheck.length > 0) || (!angular.element(evt.target).closest(target).length && !angular.element(evt.target).closest(buttonTarget).length)) {
                        $scope.extraOpen = false;
                        $scope.$apply();
                    }
                }

                target = body.find('.headerNeedHelpParent');
                if (target) {
                    if (!(target.find(evt.target).length > 0)) {
                        $scope.showNeedHelp = false;
                        $scope.$apply();
                    }
                }

                target = body.find('.headerFontSizerParent');
                if (target) {
                    if (!(target.find(evt.target).length > 0)) {
                        $scope.showFontSizer = false;
                        $scope.$apply();
                    }
                }

                target = body.find('.headerLanguageMenuParent');
                if (target) {
                    if (!(target.find(evt.target).length > 0)) {
                        $scope.showLangMenu = false;
                        $scope.$apply();
                    }
                }
            });

            // Set up scope variables for languages and meaningful-access link.
            $scope.languages = [];
            $scope.meaningfulAccessURL = null;

            $scope.showLangMenu = false;
            $scope.showFontSizer = false;
            $scope.showNeedHelp = false;
            $scope.showLoginBox = false;

            if ($location.search().returnTo === '/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/GUIDEWELLMEMBER') {
                $scope.guideWellShowLogin = false;
            } else if ($location.search().returnTo === '/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/WEBMDND?StartID=87') {
                $scope.webMDShowLogin = false;
            } else {
                $scope.guideWellShowLogin = true;
                $scope.webMDShowLogin = true;
            };


            $scope.loginInfo = {
                username: "",
                password: "",
                rememberUserName: false
            };
            /*Hardcode Values for wy/nd*/
            $scope.isMINCR = brand.current.ubk === 6010;
            $scope.isNDBCBS = brand.current.ubk === 6011;
            $scope.ndLanguageAssistance = "https://www.bcbsnd.com/documents/10181/6527267/Language_and_Disability_Access_Assistance/f6538f54-3702-4ac6-9d46-9a8b8f981df3";
            $scope.isWYBCBS = brand.current.ubk === 6012;
            $scope.isWYBCBSSNR = $scope.isWYBCBS && appId.toLowerCase() === 'medweb';

            var wyShopUrlRegex = /shop([dt]env([0-9]|[abcdet]))?\.yourwyoblue\.com/;
            //compare the webhost against the regex
            $scope.isWyShop = wyShopUrlRegex.test(window.location.host);
            $scope.translationServices = "https://www.bcbswy.com/docs/Translation_NonDiscrimination.pdf";


            var hmShopUrlRegex = /shop([dt]env([0-9]|[abcdet]))?\.highmark\.com/;
            $scope.isHmShop = hmShopUrlRegex.test(window.location.host);
            if ($scope.isHmShop) {
                hook.register("toggleChatAvailabilityOn", function () {
                    $scope.disableClickToChat = false;
                });
                hook.register("toggleChatAvailabilityOff", function () {
                    $scope.disableClickToChat = true;
                });
                $scope.$watch(function () {
                    return brand.current.sharedBrandCode;
                }, function (newValue, oldValue) {
                    //if in HM domain on shop site
                    //retrieve Branded/general content from the CMS tool
                    aemContent.get("HMSHOP_NEED_HELP_CONTENT").then(function (data) {
                        var curBrand = brand.current.sharedBrandCode.toLowerCase();
                        try {
                            var aemContentData = JSON.parse(data);
                            $scope.hmCallBlock = aemContentData.callBlock[curBrand];
                            $scope.hmStoreBlock = aemContentData.storeBlock;
                            var requestTemp = aemContentData.requestBlock.html.replace("link", "https://" + window.location.host + aemContentData.requestBlock.link);
                            $scope.hmRequestBlock = requestTemp;
                            $scope.hmChatBlockHead = aemContentData.chatBlock.chatHeader;
                            $scope.hmChatBlockLink = aemContentData.chatBlock.chatLinkText;
                            $scope.hmChatBlockFoot = aemContentData.chatBlock.chatFooter;
                        } catch (exception) {
                            console.log(exception);
                        }
                    });
                });
            }

            if (appId.toLowerCase() === 'medweb') {
                $scope.CSPhoneNumber = '<br><br>1-866-856-6166<br>Or<br>The number on the back of your member ID card<br>8:00 AM - 8:00 PM<br>7 days/week<br>TTY: Dial 711';
            }

            $scope.shouldShowLanguagesHeader = false;
            var populateHeaderLanguagesMenu = function () {
                var tagalog = {
                    'languageCode': 'tl',
                    'languageName': 'Tagalog',
                    'isRTL': false,
                    'nativeName': 'Tagalog'
                };

                // Set up $scope.languages based off of aemContent.
                aemContent.get(REGIONAL_LANGUAGES_CONTENT_ID).then(
                    function (response) {
                        var regionalLanguages = JSON.parse(response);
                        // For each langugage code in the languages property, ...
                        angular.forEach(regionalLanguages.languages, function (item) {
                            // ...if the language code is in allLanguages, ...
                            if (allLanguages[item]) {
                                // ...push the language information from allLanguages into $scope.languages.
                                if ($scope.isWYBCBS && item === 'tl') {
                                    $scope.languages.push(tagalog);
                                } else {
                                    $scope.languages.push(allLanguages[item]);
                                }
                            }
                        });
                    }, function (/*error*/) {
                    }
                );

                // Get the URL for the meaningful-access page from aemContent.
                aemContent.get(MBR_MEANINGFUL_ACCESS_LINK_ID).then(
                    function (response) {
                        var languageLink = JSON.parse(response);
                        $scope.meaningfulAccessURL = languageLink.href;
                    }, function (/*error*/) {
                    }
                );
            };

            $scope.logInButton = function () {
                $scope.showLoginBox = !$scope.showLoginBox;
                coremetrics.pageviewTag('LOGIN', 'LOGIN');
                coremetricsConversionTracker.start('LOGIN', 'LOGIN');
            };
            hook.register("triggerLoginBox", function () {
                $timeout(function () {
                    $scope.logInButton();
                    $anchorScroll();
                }, 0);
            });

            $scope.closeLanguagesMenu = function () {
                $scope.showLangMenu = false;
            };

            $scope.logout = function () {
                // fix for CHMPVD logout that doesn't redirect; scope needs to be manually cleared to avoid displaying previously logged in info
                $scope.loginInfo.username = "";
                $scope.loginInfo.password = "";
                if((window.location.href.indexOf("/find-a-doctor/")!= -1)&&(session.data.basicInfo.role == "BA" || session.data.basicInfo.role == "SBA")){
                    session.logout();
                }
                else{
                    session.logoutWithRedirect();
                }
            };
            $scope.isEmaterials = session.isEmaterials();
            $scope.login = function () {
                if ($scope.loginForm.$valid) {
                    $scope.loggingIn = true;
                    $scope.showInvalidUserPass = false;
                    $scope.showAlertIcon = true;
                    services.rbsmbl.loginversion().fetch($scope.loginInfo.username).then(function (response) {
                        if (response && response.data && response.data.payload) {
                            if (response.data.payload.loginVersion == 'MER_LOGIN_V1') {
                                services.rbsmbl.login().loginWithRedirect($scope.loginInfo.username, response.data.payload.convertCase ? $scope.loginInfo.password.toUpperCase() : $scope.loginInfo.password, null, null, true).then(function (response) {
                                    if ($window.location.href.search(/medicare.*\./) > -1) {
                                        // Don't redirect us, you are forcing a page refresh on our application, which is already slow and painful.
                                        // This logic should go in a hook in the future, so that applications can control who gets redirected.
                                        // This if statement is intentionally blank.
                                        // ~Sincerely, From everyone at the Sales Portal MEDWEB team.
                                    } else if (response.data.payload.loginInfo.userInfo.brand == "MINCR") {
                                        $window.location.href = "/member/home";
                                    } else {
                                        $window.location.href = "/mbr/#!/landing";
                                    }
                                    coremetricsConversionTracker.finish('LOGIN', 'LOGIN');
                                    // Yay
                                    $scope.loggingIn = false;
                                }, function (error) {
                                    $scope.loginInfo.username = "";
                                    $scope.loginInfo.password = "";
                                    $scope.loggingIn = false;
                                    $scope.loginErrorContent = error.specificErrorContent;

                                    // If the error wasn't just due to a wrong user/pass combo
                                    $scope.showLoginBox = $scope.showMobileLoginBox = false;
                                    $scope.showLoginMessage = true;

                                    // If error was simply due to wrong username or password, hide the loginMessageBox and display the error inside the login form
                                    if (error.data && error.data.baseMessage) {
                                        switch (error.data.baseMessage.returnCodeDescription) {
                                            case "GEN-NORECCHMECS":
                                            case "GEN-NOMATCH":
                                            case "USER-NOT-ON-FILE":
                                                $scope.showLoginBox = $scope.showMobileLoginBox = true;
                                                $scope.showInvalidUserPass = true;
                                                $scope.showLoginMessage = false;
                                                break;
                                            case "GEN-NOTONPLATFORM":
                                                $scope.showAlertIcon = false;
                                                break;
                                        }
                                    }
                                });
                            } else if (response.data.payload.loginVersion === 'BV_LOGIN') {
                                //Used for session storage retrival. Any cookies left from prior sessions being cleaned up
                                $cookies.remove('producerId');
                                if (response.data.payload.convertCase === true) {
                                    $scope.loginInfo.username = $scope.loginInfo.username.toUpperCase();
                                    $scope.loginInfo.password = $scope.loginInfo.password.toUpperCase();
                                }

                                services.wcs.ltpalogin({"storeId": brand.current.storeId}).postData({},
                                    {
                                        username: $scope.loginInfo.username,
                                        password: $scope.loginInfo.password
                                    }).then(function (response) {
                                        session.start().then(function () {
                                            var returnDefer = $q.defer();
                                            returnDefer.resolve(response);
                                        });
                                        var loginData = response.data;
                                        brand.override = brand.override || loginData.regions[0].brand;
                                        //$cookies.put('producerId', loginData.nickName + loginData.userId , {path: '/', domain: '.' + (window.location.hostname).split('.').slice(1).join('.') });
                                        coremetricsConversionTracker.finish('LOGIN', 'LOGIN');
                                        $scope.loggingIn = false;
                                    },
                                    function (error) {
                                        $scope.loginInfo.username = "";
                                        $scope.loginInfo.password = "";
                                        $scope.loggingIn = false;
                                        if (error.data && error.data.baseMessage) {
                                            $scope.loginErrorContent = services.rbsmbl.login().getErrorMessage(error.data.baseMessage.returnCodeDescription) || {};
                                        } else {
                                            $scope.loginErrorContent = {};
                                        }

                                        // If the error wasn't just due to a wrong user/pass combo
                                        $scope.showLoginBox = $scope.showMobileLoginBox = false;
                                        $scope.showLoginMessage = true;

                                        // If error was simply due to wrong username or password, hide the loginMessageBox and display the error inside the login form
                                        if (error.data && error.data.baseMessage) {
                                            switch (error.data.baseMessage.returnCodeDescription) {
                                                case "GEN-NORECCHMECS":
                                                case "GEN-NOMATCH":
                                                case "USER-NOT-ON-FILE":
                                                    $scope.showLoginBox = $scope.showMobileLoginBox = true;
                                                    $scope.showInvalidUserPass = true;
                                                    $scope.showLoginMessage = false;
                                            }
                                        }
                                    });
                            }
                            else {
                                invisibleForm.submit({
                                    name: "loginForm",
                                    action: '/chmptl/chm/jsp/logon.do',
                                    inputs: {
                                        loginid: $scope.loginInfo.username,
                                        password: response.data.payload.convertCase ? $scope.loginInfo.password.toUpperCase() : $scope.loginInfo.password
                                    }
                                });
                            }
                        }
                        else {
                            // TODO FIXME handle error gracefully
                            $scope.loggingIn = false;
                        }
                    }, function (/*error*/) {
                        // TODO FIXME handle error
                        $scope.loggingIn = false;
                    });
                }
            };
            $scope.fontSize = function (size) {
                var fontSizes = ['bodyFontSmall', 'bodyFontLarge', 'bodyFontLargest'];
                angular.element(document.body).removeClass(fontSizes.join(' '));
                angular.element(document.body).addClass(fontSizes[size]);
                var fontSize = '';
                switch (size) {
                    case 0:
                        fontSize = 'SMALL';
                        break;
                    case 1:
                        fontSize = 'MEDIUM';
                        break;
                    case 2:
                        fontSize = 'LARGE';
                        break;
                }
                coremetrics.elementTag(fontSize, 'FONT SIZE');
            };
            angular.element(document.body).addClass('bodyFontSmall');
            $scope.languageModal = function (id) {
                var title, body;
                title = body = '';
                if (id === 'language_all') {
                    title = 'Additional Languages';
                    for (var lang in $scope.languages) {
                        body = body + '<section><strong class="h4">' + $scope.languages[lang].titleHTMLUnicode + '</strong>' + $scope.languages[lang].messageHTMLUnicode + '</section>';
                    }
                }
                else {
                    title = $scope.languages[id].titleHTMLUnicode;
                    body = $scope.languages[id].messageHTMLUnicode;
                }
                var coremetricsLanguage;
                switch (id) {
                    case 'language_spanish':
                        coremetricsLanguage = 'ESPANOL';
                        break;
                    case 'language_vietnamese':
                        coremetricsLanguage = 'VIETNAMESE';
                        break;
                    case 'language_russian':
                        coremetricsLanguage = 'RUSSIAN';
                        break;
                    case 'language_italian':
                        coremetricsLanguage = 'ITALIANO';
                        break;
                    case 'language_trad_chinese':
                        coremetricsLanguage = 'CHINESE';
                        break;
                    case 'language_all':
                        coremetricsLanguage = 'OTHER';
                        break;
                }
                coremetrics.elementTag(coremetricsLanguage, 'LANGUAGE');
                modal.open({
                    heading: title,
                    template: body,
                    controller: ["$scope", "brand", function ($scope, brand) {

                        switch (brand.current.sharedBrandCode) {
                            case "fl":
                            case "mn":
                            case "pp":
                            case "az":
                            case "exc":
                            case "lou":
                            case "neb":
                            case "regbcbs":
                            case "regbs":
                            case "inac":
                            case "hz":
                            case "wi":
                            case "la":
                            case "idh":
                                $scope.mbh = true;
                                break;
                            default:
                                $scope.mbh = false;
                                break;
                        }
                        if ($scope.brandData.phoneNumbers) {
                            $scope.CSPhoneNumber = '';
                            $scope.languageNonMedicare = $scope.brandData.phoneNumbers.languageNonMedicare.join(' / ');
                            $scope.languageMedicare = $scope.brandData.phoneNumbers.languageMedicare.join(' / ');
                            $scope.languageEmployer = $scope.brandData.phoneNumbers.languageEmployer.join(' / ');
                        }

                    }]
                });
                // new Modal('<div class="content-column"><strong class="h3 no-mobile no-tablet">' + title + '</strong><hr class="thick no-mobile no-tablet"><div class="margin-top"><div class="language-other-scroll">' + body + '</div></div></div>');
            };

            $scope.forgotCoremetrics = function () {
                coremetrics.elementTag('FORGOT: USERNAME OR PASSWORD', 'FORGOT');
            };
            $scope.ContactUsCoremetrics = function () {

                // Please don't keep extending this if you need custom contactUs. You need to make this a configurable value that can be set on a project level.
                var contactUsUrl = appId.toLowerCase() === 'medweb' ? brand.current.contactUs : "/msg/#!/contact-us";

                window.location = contactUsUrl;
                coremetrics.elementTag('CONTACT US', 'NEED HELP: CONTACT US');
            };
            $scope.needHelpCoremetrics = function () {
                if (!needHelpCoremtricsFlag) {
                    coremetrics.elementTag('NEED HELP', 'NEED HELP');
                    needHelpCoremtricsFlag = true;
                }
            };
            $scope.helpMobile = function () {

                if ($scope.isWYBCBSSNR) {
                    modal.open({
                        scope: $scope,
                        template: '<article class="headerNeedHelpMobile">' +
                        '<section>' +
                        '<h1>QUESTIONS?</h1>' +
                        '<p>' +
                        'We\'re here to help.<br />' +
                        'Monday-Friday 8 a.m. - 5 p.m.<br />' +
                        '<span data-ng-if="[\'AGENT\', \'AGENCY_ADMIN\', \'INTERNAL\'].indexOf(session.basicInfo.role) === -1">800-851-2227</span>' +
                        '<span data-ng-if="[\'AGENT\', \'AGENCY_ADMIN\', \'INTERNAL\'].indexOf(session.basicInfo.role) !== -1">800-442-2376</span><br/>' +
                        '<a href="mailto:medicare@bcbswy.com" data-ng-if="[\'AGENT\', \'AGENCY_ADMIN\', \'INTERNAL\'].indexOf(session.basicInfo.role) === -1">Medicare@bcbswy.com</a>' +
                        '<a href="mailto:sales.support@bcbswy.com" data-ng-if="[\'AGENT\', \'AGENCY_ADMIN\', \'INTERNAL\'].indexOf(session.basicInfo.role) !== -1">Sales.Support@bcbswy.com</a><br/>' +
                        'TTY:711, TDD: 800-696-4710.' +
                        '</p>' +
                        '</section>' +
                        '</article>'
                    });
                } else {
                    modal.open({
                        scope: $scope,
                        template: '<article class="headerNeedHelpMobile">' +
                        '<section>' +
                        '<h1>Call</h1>' +
                        '<img src="/bootstrap/v4/resources/img/icons/CallIcon32px.png" alt="">' +
                        '<p>Have questions about benefits or claims? Or need support in your language? Please call the number on the back of your member ID card.</p>' +
                        '<p data-ng-if="brandData.phoneNumbers.languageDisability" class="margin-top">We provide free accommodations for those with disabilities.' +
                        '<span data-ng-if="brandData.phoneNumbers.languageDisablityText" >For help call  {{brandData.phoneNumbers.languageDisability}} and give the operator the number on the back of your member ID card.</span>' +
                        '<span data-ng-if="brandData.phoneNumbers.languageDisability && !brandData.phoneNumbers.languageDisablityText">TTY users call   {{brandData.phoneNumbers.languageDisability}}</span>' +
                        '<span data-ng-if="brandData.phoneNumbers.TTY && !brandData.phoneNumbers.languageDisablityText" class="margin-top"> or dial {{brandData.phoneNumbers.TTY}}.</span></p>' +
                        '<p data-ng-if="brandData.phoneNumbers.languageDisablityText" >TTY users dial {{brandData.phoneNumbers.TTY}}.</p>' +
                        '<p data-ng-if="brandData.phoneNumbers.technical" class="margin-top">If you have a technical question about this website, please call <br /> {{brandData.phoneNumbers.technical}}.</p>' +
                        '</section>' +
                        '<section data-ng-if="!session.tempPassword && session.loggedIn">' +
                        '<h1>Click</h1>' +
                        '<img data-ng-src="/bootstrap/v4/resources/img/icons/ClickIcon32px.png" alt="">' +
                        '<p>If you have any questions or concerns, please feel free to <a href="/msg/#!/contact-us">Contact Us</a> and we will get back to you soon.</p>' +
                        '</section>' +
                        '</article>'
                    });
                }
            };
            var headerTabGlow = function (state) {
                $scope.selectedTabText = '';
                if (state && $scope.navigation) {
                    for (var i in $scope.navigation.headerTabs) {
                        if ($scope.navigation.headerTabs[i].rootState === state.name.split('.')[0]) {
                            $scope.navigation.headerTabs[i].active = true;
                            $scope.selectedTabText = $scope.navigation.headerTabs[i].label;
                        }
                        else {
                            $scope.navigation.headerTabs[i].active = false;
                        }
                    }
                }
                if (state && state.data && state.data.headerText) {
                    $scope.selectedTabText = state.data.headerText;
                }
            };
            $scope.brandData = brand.current;
            $scope.navigation = navigation.data;
            $scope.hasMessageCenter = (typeof $scope.brandData.messageCenter !== "undefined") ? $scope.brandData.messageCenter : true;
            $scope.$watchCollection('navigation', function () {
                headerTabGlow($state.current);
            });
            $scope.session = session.data;
            //smart message section check
            //$scope.smartMessage = (brand.current.sharedBrandCode.toLowerCase() == 'mincr') ? true : false;

            $scope.$watch('session.loggedIn', function () {
                // reset scoped variables that can change during login/logout to their default values
                $scope.allowNeedHelp = true;
                $scope.shouldShowLanguagesHeader = $scope.isWYBCBS || $scope.isNDBCBS ? true : taglines.shouldShowLanguages($scope.session.appConfig, $scope.showLanguages);
                if ($scope.shouldShowLanguagesHeader) {
                    populateHeaderLanguagesMenu();
                }

                if ($scope.session.loggedIn) {
                    // Post Password Header
                    if (session.data.basicInfo) {
                        if (session.data.basicInfo.role && session.data.basicInfo.role.toLowerCase) {
                            if (~["ba", "bacancelled","mcu_admin"].indexOf(session.data.basicInfo.role.toLowerCase())) {
                                $scope.shouldShowLanguagesHeader = false;
                                $scope.allowNeedHelp = false;
                            }
                        }
                        //redirecting telesales users to Producer
                        if (["telesales", "agent", "agency_admin", "internal"].indexOf(session.data.basicInfo.role.toLowerCase()) > -1) {
                            if (session.data.basicInfo.temporaryPasswordFlag) {
                                window.location.href = 'https://' + window.location.hostname.replace("medicare", "producer");
                            }
                        }

                        $scope.friendlyName = session.data.basicInfo.firstName.toLowerCase();
                        if ($scope.hasMessageCenter && session.data.memberInfo) {
                            services.rbsmbl.countUnreadMessages().fetch(session.data.memberInfo).then(function (response) {
                                if (response && response.data && response.data.payload && response.data.payload[0]) {
                                    $scope.unreadMessagesCount = response.data.payload[0].unreadMessagesCount;
                                }
                            });
                        }
                        if ($scope.hasMessageCenter && session.data.memberInfo) {
                            services.rbsmbl.csPhoneNumber().fetch(session.data.memberInfo).then(function (response) {
                                if (response && response.data && response.data.payload) {

                                    var CSPhoneNumber = response.data.payload.CSPhoneNumber;

                                    if (CSPhoneNumber && CSPhoneNumber.replace(/\s/g, '').length > 0) {
                                        var lastFour, middleThree, areaCode, international, len;
                                        len = CSPhoneNumber.length;

                                        lastFour = CSPhoneNumber.substring(len - 4, len);
                                        middleThree = CSPhoneNumber.substring(len - 7, len - 4);
                                        areaCode = CSPhoneNumber.substring(len - 10, len - 7);
                                        international = (len == 11) ? CSPhoneNumber.substring(len - 11, len - 10) + '-' : '';
                                        CSPhoneNumber = international + areaCode + '-' + middleThree + '-' + lastFour;
                                        $scope.CSPhoneNumber = '';
                                        $scope.CSPhoneNumber = CSPhoneNumber;
                                    }
                                }
                            });
                        }
                        // TODO: is the line below still necessary?
                        headerTabGlow($state.current); // TODO: is this exact line of code still necessary?
                        // TODO: is the line above still necessary?
                    }
                    if (session.isEmaterials()) {
                        $scope.allowNeedHelp = false;
                    }
                }
            });

            $scope.showClickToChat = false;
            $scope.disableClickToChat = false;

            clickToChat.showClickToChat().then(
                function (response) {
                    $scope.showClickToChat = response;
                    clickToChat.disableClickToChat().then(
                        function (response) {
                            $scope.disableClickToChat = response;
                        },
                        function (response) {
                            console.error(response);
                        }
                    );
                },
                function (response) {
                    console.error(response);
                }
            );
            $scope.clickToChat = function () {
                clickToChat.openClickToChat();
            };

            $scope.windowLocation = function (url) {
                window.location = url;
            };

            $scope.$on('$stateChangeSuccess', function (event, toState/*, toParams, fromState, fromParams*/) {
                $scope.navopen = false;
                headerTabGlow(toState);
            });
        }]);
};
